// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oznrG","colBig":"styles_colBig__3Oqxp","colSmall":"styles_colSmall__13NQf"};